import AccessDeniedPage from "@/shared/components/error-pages/access-denied-page";
import ServiceUnavailablePage from "@/shared/components/error-pages/service-unavailable-page";
import { normalizeHttpError } from "@/shared/utils/errors/http-error.factory";
import { useRouteError } from "react-router-dom";

export const RootError = () => {
  const error = useRouteError();
  const httpError = normalizeHttpError(error);

  // If 503 Service Unavailable (maintenance mode), display with sidebar
  if (httpError.isServiceUnavailable) {
    return <ServiceUnavailablePage />;
  }

  // For all other errors, display access denied page (full-screen)
  return <AccessDeniedPage />;
};
